export default __webpack_public_path__ + "static/pic02-4d520c6eaacf11f36bd7d9117483ed6c.jpg";